import apiClient from './apiClient'
import { logger } from '../utils/logger'
import { 
  CreateFlowConfigRequest, 
  UpdateFlowConfigRequest,
  FlowConfigResponse,
  FlowConfigsResponse,
  FlowConfigTestResponse,
  FlowConfigValidationResponse,
  FlowCredential,
  CreateFlowCredentialRequest
} from '../types/flowConfig.types'

export class FlowConfigService {
  // Listar fluxos
  static async getFlowConfigs(page = 1, limit = 100, search = '', is_active?: boolean) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
      ...(is_active !== undefined && { is_active: is_active.toString() })
    })

    return apiClient.get<FlowConfigsResponse>(`/flow-configs?${params}`)
  }

  // Buscar fluxo por ID
  static async getFlowConfig(id: number) {
    return apiClient.get<FlowConfigResponse>(`/flow-configs/${id}`)
  }

  // Criar fluxo
  static async createFlowConfig(data: CreateFlowConfigRequest) {
    return apiClient.post<FlowConfigResponse>('/flow-configs', data)
  }

  // Atualizar fluxo
  static async updateFlowConfig(data: UpdateFlowConfigRequest) {
    logger.debug('🔍 DEBUG flowConfigService updateFlowConfig: Iniciando atualização...')
    logger.debug('🔍 DEBUG flowConfigService updateFlowConfig: Dados básicos', { flowId: data.id, hasSteps: Boolean((data as any)?.flow_config?.steps) })
    logger.debug('🔍 DEBUG flowConfigService updateFlowConfig: URL:', `/flow-configs/${data.id}`)
    
    try {
      const response = await apiClient.put<FlowConfigResponse>(`/flow-configs/${data.id}`, data)
      logger.debug('🔍 DEBUG flowConfigService updateFlowConfig: Sucesso', { status: response?.status, flowId: data.id })
      return response
    } catch (error) {
      logger.error('🔍 DEBUG flowConfigService updateFlowConfig: Erro:', error)
      throw error
    }
  }

  // Deletar fluxo
  static async deleteFlowConfig(id: number) {
    return apiClient.delete(`/flow-configs/${id}`)
  }

  // Testar fluxo
  static async testFlowConfig(id: number, testData?: object) {
    return apiClient.post<FlowConfigTestResponse>(`/flow-configs/${id}/test`, {
      test_data: testData || {}
    })
  }

  // Validar configuração do fluxo
  static async validateFlowConfig(flowConfig: object) {
    return apiClient.post<FlowConfigValidationResponse>('/flow-configs/validate', {
      flow_config: flowConfig
    })
  }

  // Credenciais externas para fluxos
  static async getCredentials(search = '') {
    const params = new URLSearchParams({ ...(search && { search }) })
    return apiClient.get<{ success: boolean; data: FlowCredential[] }>(`/flow-configs/credentials?${params}`)
  }

  static async createCredential(data: CreateFlowCredentialRequest) {
    return apiClient.post<{ success: boolean; data: FlowCredential }>('/flow-configs/credentials', data)
  }

  static async updateCredential(id: number, data: Partial<CreateFlowCredentialRequest>) {
    return apiClient.put<{ success: boolean; data: FlowCredential }>(`/flow-configs/credentials/${id}`, data)
  }

  static async deleteCredential(id: number) {
    return apiClient.delete<{ success: boolean; message: string }>(`/flow-configs/credentials/${id}`)
  }
}

// Exportar a classe diretamente para usar métodos estáticos
export { FlowConfigService as flowConfigService }
